export enum EActionCode {
  Undefined = 999,
  NP_RT_notif_button = 1000,
  NP_Offer_menu = 1001,
  NP_Push_info = 1002,
  NP_Urgency_feeling = 1003,
  NP_Right_column = 1004,
  NP_Tutorial = 1005,
  NP_Floating_button = 1006,
  NP_CRM_email_external = 1007,
  NP_CRM_email_BAL = 1008,
  NP_CRM_Push = 1009,
  NP_Seasonal_HPTO = 1010,
  NP_Permanent_Promotional_layer = 1011,
  NP_Seasonal_Promotional_layer = 1012,
  NP_Permanent_Headband = 1013,
  NP_Seasonal_headband = 1014,
  NP_Contextualized_Breaker = 1015,
  NP_CARD = 1016,
  NP_PROFILE_CAPTURE = 1017,
  NP_RA_FUNNEL = 1018,
  NP_SPLASHSCREEN = 1019,
  NP_BACK_PAYMENT_PAGE = 1020,
  NP_UNSOLD_ADS = 1021,
  NP_OBO = 1022,
  CTA_PROFILE = 1023,
  CTA_onlines = 1024,
  CTA_highlight_similarities = 1025,
  CTA_around_me = 1026,
  CTA_i_like_them = 1027,
  CTA_we_like_each_other = 1028,
  CTA_advanced_search = 1029,
  CTA_saved_search = 1030,
  CTA_quick_search = 1031,
  CTA_photo_album = 1032,
  CTA_similar_profile = 1033,
  Read_mail_user = 1034,
  ATF_DATEROULETTE_LIST_RECEIVED = 1035,
  ATF_VISIT_LIST_RECEIVED = 1036,
  ATF_FAVOURITE_LIST_RECEIVED = 1037,
  ATF_WINK_LIST_RECEIVED = 1038,
  ATF_BAL_ACKNOWLEDGMENT_READING = 1039,
  ATF_GREYLIST = 1040,
  ATF_UNAVAILABLE_MODE = 1041,
  ATF_AWAY_MANAGEMENT = 1042,
  ATF_PHOTO_LIKE_LIST_RECEIVED = 1043,
  ATF_CONTACT_FILTER_PARAM = 1044,
  ATF_POST_EVENT = 1045,
  CTA_WINK_LIST_SENT = 1046,
  ATF_PROFILE_DISPLAY_THEIRIDEAL = 1047,
  NP_PROMOTION_IN_BAL = 1048,
  NP_NRC_ACCOUNT_MANAGEMENT = 1049,
  CTA_blacklist = 1050,
  NP_Permanent_Breaker = 1051,
  CTA_mutual = 1052,
  CTA_FAV_LIST_SENT = 1053,
  VENUS_LIST = 1054,
  CTA_MESSAGE_BAL = 1055,
  CTA_PLACES = 1056,
  ATF_after_mail_user_with_FTI = 1057,
  CTA_Reveal_picture = 1058,
  CTA_lock_photo = 1059,
  NP_SO_ON_SITE_SPLASH_SCREEN = 1060,
  CTA_INTERMEDIATE_PAGE = 1061,
  CTA_INTERMEDIATE_MUTUAL_MATCH_PAGE = 1062,
  CTA_INTERMEDIATE_INVITATION_PAGE = 1063,
  CTA_CHATBOT = 1064,
  CTA_THEIR_FAVORITES_FEEDS = 1065,
  FAV_LIST_RECEIVED = 1075,
  SECOND_LIST_ACCESS = 1076,
  COMPATIBILITY_REPORT_BREAKER = 1077,
  CTA_COMPAT_REPORT = 1133,
  CTA_AFTER_FTI_FULL_SCREEN = 1081,
  CTA_AFTER_ANSWER_RECEIVED = 1082,
  CTA_AFTER_ANSWER_SEND = 1083,
  CTA_HEADER_MENU = 1084,
  CTA_BREAKER_HOME = 1120,
  CTA_BANDEAU_HOME = 1121,
  CTA_PROFILE_PICTURE_DISCOVER = 1103,
  CTA_PHOTO_GALLERY_DISCOVER = 1104,
  CTA_EXPLORE_PAGE = 1105,
  CTA_FAV_RECEIVED = 1106,
  CTA_PHOTO_REQUEST_PAGE = 1107,
  CTA_MY_SUBSCRIPTION = 1108,
  CTA_CONFIDENTIALITY_SET_UP = 1109,
  CTA_FTI_DESKTOP = 1110,
  CTA_FTA_DESKTOP = 1111,
  CTA_ANSWER_RECEIVED = 1112,
  CTA_PROFILE_DISPLAY_PICTURE = 1114,
  CTA_PROFILE_DISPLAY_GALLERY = 1115,
  CTA_INPUT_DISCOVER = 1128,
  CTA_INPUT_PROFILE = 1126,
  BREAKER_MESSAGE_PROFIL = 1127,
}
